import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Truncate from 'react-truncate';
import { useTranslation } from 'react-i18next';
import SunIcon from '../../SunIcon.jsx';
import Scrollbar from '../../../Scrollbar';

function CompareCareersSection(props) {
  const {
    dynamicTitleTextColor,
    dynamicCareersColor,
    dynamicSectionClass,
    dynamicSectionTitle,
    checkMainSectionsDisplay,
    careerList,
    addLine,
  } = {
    ...props,
  };

  const { t } = useTranslation();

  const handleCareerSelected = (career) => {
    const params = new URLSearchParams(props.location.search);
    const firstCareer = params.get('career');

    // Is this the first career modal to open or the second?
    if (firstCareer) {
      // Don't clog the history with career comparisons
      props.history.replace({
        search: props.location.pathname.includes('user-profile')
          ? `?userId=${props.userProfileId}&tenantId=${
              props.userProfileTenantId
            }&career=${encodeURIComponent(
              firstCareer
            )}&career2=${encodeURIComponent(career.titleEn)}&swap=false`
          : `?career=${encodeURIComponent(
              firstCareer
            )}&career2=${encodeURIComponent(career.titleEn)}&swap=false`,
        state: props.location.pathname.includes('user-profile')
          ? {
              userId: props.userProfileId,
              tenantId: props.userProfileTenantId,
            }
          : null,
      });
    } else {
      props.history.push({
        search: `?career=${encodeURIComponent(career.titleEn)}&swap=false`,
      });
    }

    // Redisplay original career content for this modal
    checkMainSectionsDisplay(true);
  };

  // This is for the placeholder lists for each of the 3 categories before a user searches a career
  // We need to sort both the 'Favorites' and 'Top 25' lists but NOT the 'All Careers'
  const makeTempCareerList = (tempList) => {
    const sorted =
      dynamicSectionTitle !== 'All Careers'
        ? tempList.sort((a, b) => (a.titleEn > b.titleEn ? 1 : -1))
        : tempList;

    return sorted.map((career) => (
      <li
        data-cy="career-item"
        role="button"
        tabIndex={0}
        className={[
          'career-item',
          dynamicSectionClass,
          dynamicCareersColor,
        ].join(' ')}
        key={career.id}
        onClick={() => handleCareerSelected(career)}
        onKeyDown={(e) => {
          if (['Enter'].includes(e.key)) handleCareerSelected(career);
        }}
      >
        <Truncate lines={1} ellipsis="..." className="career-item-text">
          <p data-cy="career-item-text">{career.titleEn}</p>
        </Truncate>
        {career.careerOutlook ? <SunIcon width="15px" /> : null}
      </li>
    ));
  };

  const getSectionTitleTranslated = (titleKey) => {
    const translationMap = {
      Favorites: t('Favorites'),
      'Top 25': t('Top 25'),
      'All Careers': t('All Careers'),
    };
    return translationMap[titleKey] || '';
  };

  return (
    <>
      <Scrollbar
        className={
          dynamicSectionClass === 'all-careers'
            ? 'all-careers-scroll'
            : 'favorites-top25-scroll'
        }
      >
        <div className={['career-list', dynamicSectionClass].join(' ')}>
          <p
            className={[
              'list-title',
              dynamicTitleTextColor,
              dynamicSectionClass,
            ].join(' ')}
          >
            {getSectionTitleTranslated(dynamicSectionTitle)}
          </p>

          <ul data-cy="career-section-list">
            {makeTempCareerList(careerList)}
          </ul>
        </div>
      </Scrollbar>
      {addLine ? <hr className="horizontal-line" /> : null}
    </>
  );
}

const mapStateToProps = (state) => {
  const userProfileId = state.admin.userProfileInfo?.id;
  const userProfileTenantId = state.admin.userProfileInfo?.tenantId;

  return { userProfileId, userProfileTenantId };
};

const compareCareersSectionWithRouter = withRouter(
  connect(mapStateToProps)(CompareCareersSection)
);

export default compareCareersSectionWithRouter;
